// extracted by mini-css-extract-plugin
module.exports = {"page":"notice_page__3v8MF","create":"notice_create__eubeB"};